{
  "open": "Консоль",
  "title": "Консоль {{name}}",
  "clickToType": "Нажмите на экран, чтобы печатать со своей клавиатуры",
  "off": {
    "title": "Сервер выключен",
    "text": "Консоль показывает экран работающего сервера. Включите его — загрузку будет видно с первой секунды.",
    "powerOn": "Включить"
  },
  "failed": {
    "title": "Не удалось подключиться к консоли",
    "text": "Соединение прервалось или не установилось. Переподключение откроет новый сеанс."
  },
  "disconnected": {
    "title": "Консоль отключена",
    "text": "Сеанс закончился. Переподключитесь, чтобы продолжить."
  },
  "keyboard": {
    "label": "Экранная клавиатура",
    "modifiersHint": "Ctrl, Alt, Shift и Win держатся до следующей клавиши",
    "native": "Системная клавиатура",
    "functionKeys": "F1–F12"
  },
  "typeDialog": {
    "title": "Набрать текст",
    "description": "Консоль получает нажатия клавиш, а не текст: каждый символ будет набран так, как на английской (US) клавиатуре. Русские буквы и эмодзи не наберутся — для них подключитесь по SSH.",
    "field": "Текст",
    "enter": "Нажать Enter в конце",
    "submit": "Набрать",
    "skipped": "Пропущено символов не с раскладки US: {{count}}",
    "descriptionRu": "Консоль получает нажатия клавиш, а не текст: каждый символ будет набран клавишами русской раскладки (ЙЦУКЕН) — включите её на сервере. Латинские буквы так не наберутся."
  }
}
